module.exports = __webpack_public_path__ + "img/mat_4.8fcb1ef8.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":1200,"height":894,"variants":[{"file":"img/mat_4-480w.c7548e727848.webp","width":480},{"file":"img/mat_4-960w.1a03e75c89c4.webp","width":960},{"file":"img/mat_4-1200w.f2f9a5c781d4.webp","width":1200}]};
}